import { useTranslation } from "react-i18next";

interface FreeVehicleReturnHintProps {
  isFreeVehicleReturnToggled: boolean;
  onClick: () => void;
}

export function FreeVehicleReturnHint({
  isFreeVehicleReturnToggled,
  onClick,
}: FreeVehicleReturnHintProps) {
  const { t } = useTranslation();

  const handleClick = () => {
    onClick();
  };
  return (
    <div className={"p-4 text-sm bg-primary shadow-sm rounded-md mb-4 text-white"}>
      <p className={"mb-1"}>{t("booking.vehicleReturn.free-return.text")}</p>
      {isFreeVehicleReturnToggled ? (
        <button
          type={"button"}
          onClick={handleClick}
          className={"text-left text-normal font-bold underline underline-offset-1"}
        >
          {t("booking.vehicleReturn.free-return.view-all")}
        </button>
      ) : (
        <button
          type={"button"}
          onClick={handleClick}
          className={"text-left text-normal font-bold underline underline-offset-1"}
        >
          {t("booking.vehicleReturn.free-return.view-free")}
        </button>
      )}
    </div>
  );
}
